import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const RefundsPage = lazyWithRetry(() =>
  import("@/features/refunds/pages/RefundsPage").then((m) => ({ default: m.RefundsPage })),
);
const RefundDetailPage = lazyWithRetry(() =>
  import("@/features/refunds/pages/RefundDetailPage").then((m) => ({ default: m.RefundDetailPage })),
);

export const REFUNDS_PATH = "/remboursements";

const refundsRoutes: RouteConfig[] = [
  {
    path: REFUNDS_PATH,
    element: <RefundsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: `${REFUNDS_PATH}/:id`,
    element: <RefundDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default refundsRoutes;
